<template>
  <v-container>
    <v-row no-gutters v-if="poi.id">
      <v-col>
        <v-row>
          <v-col>
            <v-row class="flex-nowrap">
            <v-btn small @click="takeScreenshot($refs.preview)" color="primary mt-2 mr-2">
              take ss
            </v-btn>
            <v-btn small @click="takeScreenshot($refs.badge)" color="primary mt-2 mr-2">
              take text
            </v-btn>
            <v-btn @click="nextVideo" small color="mt-2">
              next video
            </v-btn>
            </v-row>
          </v-col>
          <a v-show="false" ref="download" />
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-slider
              color="orange darken-3"
              height="100%"
              vertical min="0"
              max="100"
              v-model="preview.badgeTopPos"
            />
          </v-col>
          <v-col cols="11">
            <v-row ref="preview" class="mt-1" :style="{ position: 'relative' }">
              <video
                crossorigin="anonymous"
                :src="poi.videos[video_index].uri"
                controls />
              <div
                ref='badge'
                class="teaser-body"
                :style="{ top: `calc(${100 - preview.badgeTopPos}% - 0.8em)` }"
              >
                <div class="badge teaser-badge" :style="{ background: preview.color }">
                  <div v-if="preview.row1" class="badge-type">
                    {{ preview.row1 }}
                  </div>
                  <div v-if="preview.row2" class="badge-name">
                    {{ preview.row2 }}
                  </div>
                </div>
                <div class="teaser-hashtag" v-if="preview.row3">
                  <span class="hashtag">#{{ preview.row3 }}</span>
                </div>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  name: 'PoiBanner',

  props: {
    preview: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      video_index: 0,
      poi: {},
    };
  },

  created() {
    this.$watch(
      () => this.$route.params.poiId,
      () => { this.fetchPoi(); },
    );
    this
      .fetchPoi(this.$route.params.poiId)
      .then(() => { this.$emit('initialized', this.poi); });
  },

  methods: {
    fetchPoi() {
      return this.$requestHelpers
        .get(`api/admin/poi/getHighQualityVideoLinks/${this.$route.params.poiId}`)
        .then(({ data }) => {
          this.poi = data;
        });
    },

    nextVideo() {
      this.video_index = this.poi.videos[this.video_index + 1]
        ? this.video_index + 1
        : 0;
    },

    takeScreenshot(el) {
      html2canvas(el, { scale: 4, backgroundColor: null }).then((canvas) => {
        const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        this.$refs.download.setAttribute('download', `${this.poi.name.replace(' ', '_')}.png`);
        this.$refs.download.setAttribute('href', image);
        this.$refs.download.click();
      });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap');
video {
  max-width: 100%;
}
.teaser-body {
  position: absolute;
  width: 100%;
  text-align: center;
  padding-top: 0.8em;
}
.badge {
  font-family: Rubik, sans-serif;
  font-size: 16px;
  max-width: 90%;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  border-radius: 0.5em 3em;
  text-align: center;
  padding: 1.5em 1em;
  min-height: 8em;
  font-weight: 500;
  letter-spacing: -.5px;
}
.badge-type {
  font-size: 22px;
  line-height: 1.2em;
  letter-spacing: -.05em;
  color: #fff;
  text-shadow: 0 0 2px rgb(0 0 0 / 80%);
}
.badge-name {
  font-size: 32px;
  line-height: 1em;
  font-weight: 700;
}
.teaser-hashtag {
  font-family: Rubik, sans-serif;
  position: relative;
  top: -0.8em;
  text-align: center;
}
.hashtag {
  display: inline-block;
  padding: 0.2em;
  background: #000;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}
/deep/ .v-slider--vertical, .v-input__slider--vertical {
  height: 100%;
}
</style>
